import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { RecommendationFeed } from "@/components/control-tower/RecommendationFeed";
import { useDashboardStats } from "@/lib/api/useDashboardStats";
import { useFilteredBuildings } from "@/lib/inventory-scope";

export const Route = createFileRoute("/recommendations")({
  component: RecommendationsPage,
});

function RecommendationsPage() {
  const state = useDashboardStats();
  const buildings = useFilteredBuildings(
    state.status === "ok" ? state.buildings : [],
  );

  return (
    <Shell
      title="Suositukset"
      subtitle="AI-ehdotukset · järjestys: uusimmat ensin"
    >
      <RecommendationFeed buildings={buildings} />
    </Shell>
  );
}
